import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Chip,
  Snackbar,
  Button,
  Grid,
} from '@mui/material';
import { ContentCopy, Share } from '@mui/icons-material';
import { useAuth } from '../../hooks/useAuth';

const BASE_REFERRAL_URL = 'https://zm.coinfliparena.com';   // Zambia base URL

const Referral = () => {
  const { user } = useAuth();                     // user must expose serviceCode
  const serviceCode = user?.serviceCode?.trim();

  // Final link: https://zm.coinfliparena.com?referralaffiliate=<serviceCode>
  const referralURL = serviceCode
    ? `${BASE_REFERRAL_URL}?referralaffiliate=${serviceCode}`
    : null;

  const [copied, setCopied] = useState(false);
  const [shared, setShared] = useState(false);

  const copy = () => {
    if (!referralURL) return;
    navigator.clipboard.writeText(referralURL).then(() => setCopied(true));
  };

  const shareNative = () => {
    if (!referralURL) return;
    if (!navigator.share) return copy();          // fallback
    navigator
      .share({
        title: 'Join me!',
        text: 'Check this out:',
        url: referralURL,
      })
      .then(() => setShared(true))
      .catch(() => {});                           // user cancelled / error ignored
  };

  if (!referralURL) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6">
          No referral link available for your account.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', py: 4 }}>
      <Card sx={{ borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
            Refer&nbsp;&amp;&nbsp;Earn
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Share your unique link – everyone who signs up with it is tracked
            back to you.
          </Typography>

          <Box
            sx={{
              p: 2,
              bgcolor: 'background.default',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              overflowX: 'auto',
              mb: 3,
            }}
          >
            <Typography variant="body2" sx={{ flexGrow: 1 }}>
              {referralURL}
            </Typography>

            <IconButton size="small" onClick={copy}>
              <ContentCopy fontSize="small" />
            </IconButton>

            <Chip size="small" color="primary" label={serviceCode} />
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Button
                fullWidth
                variant="contained"
                startIcon={<Share />}
                onClick={shareNative}
              >
                Share link
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<ContentCopy />}
                onClick={copy}
              >
                Copy to clipboard
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Snackbars ------------------------------------------------ */}
      <Snackbar
        open={copied}
        onClose={() => setCopied(false)}
        autoHideDuration={2500}
        message="Referral link copied!"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />

      <Snackbar
        open={shared}
        onClose={() => setShared(false)}
        autoHideDuration={2500}
        message="Thanks for sharing 🎉"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </Box>
  );
};

export default Referral;




// import React, { useState } from 'react';
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   IconButton,
//   Chip,
//   Snackbar,
//   Button,
//   Grid
// } from '@mui/material';
// import { ContentCopy, Share } from '@mui/icons-material';
// import { useAuth } from '../../hooks/useAuth';

// const Referral = () => {
//   const { user } = useAuth();                // user must expose serviceCode
//   const serviceCode  = user?.serviceCode?.trim();
//   const referralURL  = serviceCode
//     ? `${window.location.origin}/${serviceCode}`
//     : null;

//   const [copied,  setCopied]  = useState(false);
//   const [shared,  setShared]  = useState(false);

//   const copy = () =>
//     navigator.clipboard.writeText(referralURL).then(() => setCopied(true));

//   const shareNative = () => {
//     if (!navigator.share) return copy();     // fallback
//     navigator
//       .share({
//         title:   'Join me!',
//         text:    'Check this out:',
//         url:     referralURL,
//       })
//       .then(() => setShared(true))
//       .catch(() => {});                      // user cancelled
//   };

//   if (!referralURL) {
//     return (
//       <Box sx={{ p: 4, textAlign: 'center' }}>
//         <Typography variant="h6">
//           No referral link available for your account.
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ maxWidth: 800, mx: 'auto', py: 4 }}>
//       <Card sx={{ borderRadius: 2 }}>
//         <CardContent>
//           <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
//             Refer &amp; Earn
//           </Typography>

//           <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//             Share your unique link – every friend who signs up with it is tracked back to you.
//           </Typography>

//           <Box
//             sx={{
//               p: 2,
//               bgcolor: 'background.default',
//               borderRadius: 1,
//               display: 'flex',
//               alignItems: 'center',
//               gap: 1,
//               overflowX: 'auto',
//               mb: 3,
//             }}
//           >
//             <Typography variant="body2" sx={{ flexGrow: 1 }}>
//               {referralURL}
//             </Typography>

//             <IconButton size="small" onClick={copy}>
//               <ContentCopy fontSize="small" />
//             </IconButton>

//             <Chip size="small" color="primary" label={serviceCode} />
//           </Box>

//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6}>
//               <Button
//                 fullWidth
//                 variant="contained"
//                 startIcon={<Share />}
//                 onClick={shareNative}
//               >
//                 Share link
//               </Button>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Button
//                 fullWidth
//                 variant="outlined"
//                 startIcon={<ContentCopy />}
//                 onClick={copy}
//               >
//                 Copy to clipboard
//               </Button>
//             </Grid>
//           </Grid>
//         </CardContent>
//       </Card>

//       {/* Snackbars ------------------------------------------------ */}
//       <Snackbar
//         open={copied}
//         onClose={() => setCopied(false)}
//         autoHideDuration={2500}
//         message="Referral link copied!"
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       />

//       <Snackbar
//         open={shared}
//         onClose={() => setShared(false)}
//         autoHideDuration={2500}
//         message="Thanks for sharing 🎉"
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       />
//     </Box>
//   );
// };

// export default Referral;
